import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    behavior: { type: String, default: "instant" } 
  }

  connect() {
    window.scrollTo({ top: 0, behavior: this.behaviorValue })
  }
}
